import { PaymentResultComponent } from './pages/payment-result/payment-result.component';
import { CartComponent } from './pages/cart/cart.component';
import { FaqsComponent } from './pages/faqs/faqs.component';
import { RegisterComponent } from './pages/register/register.component';
import { WishlistComponent } from './pages/wishlist/wishlist.component';
import { StudentSettingsComponent } from './pages/student-settings/student-settings.component';
import { Error404Component } from './pages/error404/error404.component';
import { StudentResolver } from './core/resolvers/student.resolver';
import { StudentProfileComponent } from './pages/student-profile/student-profile.component';
import { RegisterStudentComponent } from './pages/register-student/register-student.component';
import { LoginComponent } from './pages/login/login.component';
import { TeacherResolver, TeachersResolver } from './core/resolvers/teacher.resolver';
import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AllCoursesComponent } from './pages/all-courses/all-courses.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { BecomeTeacherComponent } from './pages/become-teacher/become-teacher.component';
import { ContactComponent } from './pages/contact/contact.component';
import { TeacherDashboardComponent } from './pages/teacher-dashboard/teacher-dashboard.component';
import { TeacherProfileComponent } from './pages/teacher-profile/teacher-profile.component';
import { TeacherCourcesComponent } from './pages/teacher-cources/teacher-cources.component';
import { TeacherSettingsComponent } from './pages/teacher-settings/teacher-settings.component';
import { CreateCourseComponent } from './pages/create-course/create-course.component';
import { CourseDetailsComponent } from './pages/course-details/course-details.component';
import { TeacherViewProfileComponent } from './pages/teacher-view-profile/teacher-view-profile.component';
import { CategoriesResolver } from './core/resolvers/category.resolver';
import { CourseResolver, CoursesResolver } from './core/resolvers/course.resolver';
import { StudentCourcesComponent } from './pages/student-cources/student-cources.component';
import { TeacherPaymentsComponent } from './pages/teacher-payments/teacher-payments.component';


const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    data: {
      title: 'Home'
    },
    resolve: {
      // categories: CategoriesResolver
    }
  },
  {
    path: 'courses',
    component: AllCoursesComponent,
    data: {
      title: 'Courses'
    },
    resolve: {
      // courses: CoursesResolver,
      // teachers: TeachersResolver,
      // categories: CategoriesResolver
    }
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
    data: {
      title: 'about-us'
    }
  },
  // {
  //   path: 'become-teacher',
  //   component: BecomeTeacherComponent,
  //   data: {
  //     title: 'become-teacher'
  //   }
  // },
  // {
  //   path: 'register',
  //   component: RegisterStudentComponent,
  //   data: {
  //     title: 'Register Student'
  //   }
  // },
  {
    path: 'contact',
    component: ContactComponent,
    data: {
      title: 'contact'
    }
  },
  // {
  //   path: 'teacher-dashboard/:type/:id',
  //   component: TeacherDashboardComponent,
  //   data: {
  //     title: 'TeacherDashboard'
  //   },
  //   resolve: {
  //     teacher: TeacherResolver
  //   }
  // },
  {
    path: 'teacher-profile/:type/:id',
    component: TeacherProfileComponent,
    data: {
      title: 'TeacherProfile'
    },
    resolve: {
      teacher: TeacherResolver
    }
  },
  {
    path: 'teacher-courses/:type/:id',
    component: TeacherCourcesComponent,
    data: {
      title: 'TeacherCources'
    },
    resolve: {
      categories: CategoriesResolver
    }
  },
  {
    path: 'teacher-settings/:type/:id',
    component: TeacherSettingsComponent,
    data: {
      title: 'TeacherSettings'
    },
    resolve: {
      teacher: TeacherResolver
    }
  },
  {
    path: 'teacher-payments/:type/:id',
    component: TeacherPaymentsComponent,
    data: {
      title: 'TecherPayment'
    }
  },
  {
    path: 'create-course/:type/:id',
    component: CreateCourseComponent,
    data: {
      title: 'CreateCourse'
    },
    resolve: {
      course: CourseResolver,
      categories: CategoriesResolver
    }
  },
  {
    path: 'course-details/:type/:id',
    component: CourseDetailsComponent,
    data: {
      title: 'CourseDetails'
    },
    resolve: {
      course: CourseResolver
    }
  },
  {
    path: 'teacherprofile/:type/:id',
    component: TeacherViewProfileComponent,
    data: {
      title: 'TeacherViewProfile'
    },
    resolve: {
      teacher: TeacherResolver
    }
  },
  {
    path: 'student-profile/:type/:id',
    component: StudentProfileComponent,
    data: {
      title: 'StudentProfile'
    },
    resolve: {
      student: StudentResolver
    }
  },
  {
    path: 'student-settings/:type/:id',
    component: StudentSettingsComponent,
    data: {
      title: 'StudentSettings'
    },
    resolve: {
      student: StudentResolver
    }
  },
  {
    path: 'student-courses/:type/:id',
    component: StudentCourcesComponent,
    data: {
      title: 'StudentCources'
    },
    resolve: {
      student: StudentResolver
    }
  },
  {
    path: 'wishlist/:type/:id',
    component: WishlistComponent,
    data: {
      title:  'Wishlist'
    },
    resolve: {
      student: StudentResolver
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title:  'Wishlist'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login'
    }
  },
  {
    path: 'faqs',
    component: FaqsComponent,
    data: {
      title: 'Faqs'
    }
  },
  {
    path: 'cart',
    component: CartComponent,
    data: {
      title: 'Cart'
    }
  },
  {
    path: 'page/paymentResult/:id',
    component: PaymentResultComponent,
    data: {
      title: 'Payment'
    }
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', component: Error404Component}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
